import { ColumnDef } from "@tanstack/react-table";
import { SummaryRow } from "../model";

const cellEmphasis = (val: any, isTotal?: boolean) => (
  <span className={isTotal ? "font-semibold" : ""}>{val ?? "-"}</span>
);

export const summaryColumns: ColumnDef<SummaryRow>[] = [
  {
    header: "Currencies",
    accessorFn: (r) => r.currencies,
    cell: ({ row, getValue }) => cellEmphasis(getValue(), row.original.isTotal),
  },
  {
    header: "All Received (Inflow)",
    accessorFn: (r) => r.inflowOriginal,
    cell: ({ row, getValue }) => cellEmphasis(getValue(), row.original.isTotal),
  },
  {
    header: "Remaining to be received",
    accessorFn: (r) => r.remainingInflow,
    cell: ({ row, getValue }) => cellEmphasis(getValue(), row.original.isTotal),
  },
  {
    header: "All Paid (Outflow)",
    accessorFn: (r) => r.outflowOriginal,
    cell: ({ row, getValue }) => cellEmphasis(getValue(), row.original.isTotal),
  },
  {
    header: "Remaining to be paid",
    accessorFn: (r) => r.remainingOutflow,
    cell: ({ row, getValue }) => cellEmphasis(getValue(), row.original.isTotal),
  },
  {
    header: "Avg. Exchange Rate",
    accessorFn: (r) => r.exchangeRate,
    cell: ({ row, getValue }) => cellEmphasis(getValue(), row.original.isTotal),
  },
];
